import { darken, getValue } from "../utils.js";

export const SMARTATTACHMENT = {
  "Smartattachment.Border.Color": {
    ref: "Input.Border.Color"
  },
  "Smartattachment.Border.Top.Width": {
    ref: "Input.Border.Top.Width"
  },
  "Smartattachment.Border.Bottom.Width": {
    ref: "Input.Border.Bottom.Width"
  },
  "Smartattachment.Border.Left.Width": {
    ref: "Input.Border.Left.Width"
  },
  "Smartattachment.Border.Right.Width": {
    ref: "Input.Border.Right.Width"
  },
  "Smartattachment.Button.Border.Color": {
    ref: "Button.Tertiary.Border.Color"
  },
  "Smartattachment.Hover.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Smartattachment.Border.Color", meta), 0.2);
    }
  }
};
